// START IMPORTS
import { useSubscriptionAccessConfigContext } from '@ltvco/refresh-lib/ctx';
import { Box } from '@ltvco/refresh-lib/theme';
import { useSession } from '@ltvco/refresh-lib/v1';
import { Header } from '@ltvco/refresh-lib/v2';
import { useFeatureIsOn, useFeatureValue } from '@ltvco/refresh-lib/vendors';
import { useEffect } from 'react';

import { constants } from 'appConstants';
// END IMPORTS

// START INTERFACES_AND_TYPES
type HeaderParentProps = {
  handleSearchSuccess: any;
  changeSingleReportVariation: (variation: boolean) => void;
  changeOwnerSearchVariation: (variation: boolean) => void;
  changeIsInAstrologyStandaloneVariation: (variation: boolean) => void;
  changeInternationalLanguageTest: (variation: boolean) => void;
  changeInternationalVinTest: (variation: boolean) => void;
  changeListV2Variation: (variation: boolean) => void;
  changeCourtCasesVariation: (variation: boolean) => void;
  changeOar1946Variation: (variation: string) => void;
  changeChatBVFlowFooterVariation: (variation: boolean) => void;
};
// END INTERFACES_AND_TYPES

export const HeaderParent = ({
  handleSearchSuccess,
  changeSingleReportVariation,
  changeIsInAstrologyStandaloneVariation,
  changeInternationalLanguageTest,
  changeInternationalVinTest,
  changeListV2Variation,
  changeCourtCasesVariation,
  changeOar1946Variation,
  changeChatBVFlowFooterVariation,
}: HeaderParentProps) => {
  const {
    session: { account },
  } = useSession();

  const planName =
    account?.account?.subscription_info?.subscription_plan_unique_name ?? '';
  const isInAstrologyStandaloneVariation = useFeatureIsOn('oar-1164');
  const isInListV2Variation = useFeatureIsOn('prop-2834');
  const isInCourtCasesVariation = useFeatureIsOn('court-case-search');
  const oar1946Variation = useFeatureValue<string>('OAR-1946', '');
  const isOnChatBVFlowFooterVariation = useFeatureIsOn('prop-3640');

  const {
    singleReportVariation,
    internationalLanguageVariation,
    vinVariation,
  } = useSubscriptionAccessConfigContext();
  // END HOOKS_AND_QUERIES

  // START EFFECTS
  useEffect(() => {
    changeSingleReportVariation(singleReportVariation);
  }, [singleReportVariation]);

  useEffect(() => {
    changeIsInAstrologyStandaloneVariation(isInAstrologyStandaloneVariation);
  }, [isInAstrologyStandaloneVariation]);

  useEffect(() => {
    changeInternationalLanguageTest(internationalLanguageVariation);
  }, [internationalLanguageVariation]);

  useEffect(() => {
    changeInternationalVinTest(vinVariation);
  }, [vinVariation]);

  useEffect(() => {
    changeListV2Variation(isInListV2Variation);
  }, [isInListV2Variation]);

  useEffect(() => {
    changeCourtCasesVariation(isInCourtCasesVariation);
  }, [isInCourtCasesVariation]);

  useEffect(() => {
    changeOar1946Variation(oar1946Variation);
  }, [oar1946Variation]);

  useEffect(() => {
    changeChatBVFlowFooterVariation(isOnChatBVFlowFooterVariation);
  }, [isOnChatBVFlowFooterVariation]);

  if (location.pathname.includes('/chatbv')) {
    return null;
  }
  // END EARLY_RETURNS

  // START RENDER
  const isSpanishTranslationEnabled =
    constants.spanishTranslationPlanNames.includes(planName);

  return (
    <Box>
      <Header
        onSearchSuccess={handleSearchSuccess}
        {...(isSpanishTranslationEnabled && { translationLanguage: 'spanish' })}
      />
    </Box>
  );
  // END RENDER
};
